const TeamLoadCard = ({ teamName, tasksLoad, categoryRows = [] }) => (
  <article className="min-w-0 bg-surface px-4 pb-4 pt-3">
    <p className="mb-2 truncate text-[11px] font-semibold uppercase tracking-[0.05em] text-content-muted">
      {teamName}
    </p>
    <div className={`flex items-baseline gap-2 ${categoryRows.length > 0 ? 'mb-3' : ''}`}>
      <span className="text-2xl font-bold leading-tight text-content">{tasksLoad}</span>
      <span className="text-[11px] text-muted-deep">{tasksLoad === 1 ? 'tarea' : 'tareas'}</span>
    </div>

    {/* Sin filas no hay separador: cubre al equipo sin tareas y al detalle plegado */}
    {categoryRows.length > 0 && (
      <div className="space-y-[5px] border-t border-dashed border-line pt-2">
        {categoryRows.map((row) => (
          <div key={row.key} className="flex items-baseline gap-2">
            <span className="min-w-0 flex-1 truncate text-[11px] text-content-muted">{row.label}</span>
            <span className="font-mono text-[11px] font-semibold text-content">{row.count}</span>
          </div>
        ))}
      </div>
    )}
  </article>
);

export default TeamLoadCard;
